"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.assignmentPolicySchema = exports.assignmentPolicyParameters = exports.completionPolicySchema = exports.completionPolicyParameters = exports.microtaskAssignmentOrders = void 0;
const parameter_specs_1 = require("@karya/parameter-specs");
/**
 * Microtask assignment orders
 */
exports.microtaskAssignmentOrders = {
    SEQUENTIAL: 'Assign microtasks in sequential order',
    RANDOM: 'Assign microtasks in random order',
};
/**
 * Completion policy parameters. To be collected at the time of task creation.
 */
exports.completionPolicyParameters = [
    {
        id: 'maxAssignmentsPerMicrotask',
        label: 'Maximum Assignments Per Microtask',
        description: 'Maximum number of assignments for a microtask. Once this number is reached, a microtask will no longer be assigned to another user',
        type: 'int',
        required: false,
    },
    {
        id: 'numAcceptedResponsesPerMicrotask',
        label: 'Number of Accepted Responses Per Microtask',
        description: 'Microtask will be marked as completed once this number of accepted assignments',
        type: 'int',
        required: false,
    },
];
exports.completionPolicySchema = (0, parameter_specs_1.joiSchema)(exports.completionPolicyParameters);
/**
 * Assignment policy parameters. To be collected at the time of task assignment
 * creation.
 */
exports.assignmentPolicyParameters = [
    {
        id: 'microtaskAssignmentOrder',
        label: 'Microtask Assignment Order',
        description: 'Order in which microtasks within a task should be assigned to users',
        type: 'enum',
        list: exports.microtaskAssignmentOrders,
        required: true,
    },
    {
        id: 'assignByOwnerAccesscode',
        label: 'Assign Microtasks By Owner Accesscode',
        description: 'selects an owner access code from all assignable microtasks and groups all the microtasks with that owner accesscode before assigning. AssignmentBatchSize will be applicable on top of it in case that is given',
        type: 'boolean',
        required: false,
        default: false,
    },
    {
        id: 'tags',
        label: 'Task Assignment Tags',
        description: 'Additional tags to be attached to the task as part of the task assignment',
        type: 'list',
        required: false,
    },
    {
        id: 'maxAssignmentsPerUser',
        label: 'Maximum Assignments per User',
        description: 'Maximum number of assignments per avatar assigned to this project',
        type: 'int',
        required: false,
    },
    {
        id: 'paymentScalingFactor',
        label: 'Payment Scale',
        description: 'Scale all payments through this task assignment by the scaling factor',
        type: 'float',
        min: 0,
        max: 3.0,
        required: false,
        default: 1,
    },
    {
        id: 'assignmentBatchSize',
        label: 'Assignment Batch Size',
        description: 'Number of microtasks to be assigned with each batch',
        type: 'int',
        required: false,
    },
    {
        id: 'activeStartDate',
        label: 'Active Start Date',
        description: 'Date on which the task assignment becomes active',
        type: 'string',
        required: false,
    },
    {
        id: 'activeEndDate',
        label: 'Active End Date',
        description: 'Date on which the task assignment ceases to be active',
        type: 'string',
        required: false,
    },
    {
        id: 'expiry',
        label: 'Expiry Time for Assignments',
        description: 'Expiry time for assignments',
        type: 'string',
        required: false,
    },
    {
        id: 'dailyLimit',
        label: 'Daily Limit on Assignments',
        description: 'Daily limit on number assignments made to a user',
        type: 'int',
        required: false,
    },
    {
        id: 'weeklyLimit',
        label: 'Weekly Limit on Assignments',
        description: 'Weekly limit on number of assignments to a user',
        type: 'int',
        required: false,
    },
    {
        id: 'custom',
        label: 'Custom Assignment Parameters',
        description: 'Custom parameters that control how tasks are assigned to users',
        type: 'json_object',
        required: false,
    },
];
exports.assignmentPolicySchema = (0, parameter_specs_1.joiSchema)(exports.assignmentPolicyParameters);
//# sourceMappingURL=Index.js.map